import React from 'react';
import { Modal, Button, notification } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const BulkUploadResultModal = ({ isOpen, onClose, results }) => {
  const handleDownloadReport = () => {
    if (results?.path) {
      const link = document.createElement('a');
      link.href = results.path;
      link.target = '_blank';
      link.download = 'bulk_upload_report.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      notification.success({
        message: 'Report downloaded successfully',
      });
    }
  };

  return (
    <Modal 
      open={isOpen} 
      onCancel={onClose}
      footer={null}
      title='Bulk Update'
      width={500}
    >
      <div style={{ padding: '20px 0', textAlign: 'center' }}>
        <p style={{ marginBottom: '20px', color: '#666' }}>
          System has successfully processed the bulk update file. Please see the upload summary below:
        </p>
        <div style={{ margin: '40px 0' }}>
          <UploadOutlined style={{ fontSize: '64px', color: '#52c41a' }} />
        </div>
        <div style={{ textAlign: 'left', marginBottom: '20px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
            <span style={{ fontSize: '14px' }}>Total Records</span>
            <strong style={{ fontSize: '16px', color: '#000' }}>{results?.total_records || 0}</strong>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
            <span style={{ fontSize: '14px' }}>Added (New VINs)</span>
            <strong style={{ fontSize: '16px', color: '#52c41a' }}>{results?.added || 0}</strong>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
            <span style={{ fontSize: '14px' }}>Updated (Existing VINs)</span>
            <strong style={{ fontSize: '16px', color: '#1890ff' }}>{results?.updated || 0}</strong>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '12px 0', borderBottom: '1px solid #f0f0f0' }}>
            <span style={{ fontSize: '14px' }}>Failed (invalid or duplicate entries)</span>
            <strong style={{ fontSize: '16px', color: '#ff4d4f' }}>{results?.failed || 0}</strong>
          </div>
        </div>
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
          <Button 
            type='link' 
            onClick={handleDownloadReport} 
            style={{ padding: 0, fontSize: '14px', color: '#1890ff' }}
            disabled={!results?.path}
          >
            Download &quot;Upload Report&quot; XLS File
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default BulkUploadResultModal;












